import { render, staticRenderFns } from "./ConfirmBulkTransactionsReversal.vue?vue&type=template&id=52bd9a4e"
import script from "./ConfirmBulkTransactionsReversal.vue?vue&type=script&lang=js"
export * from "./ConfirmBulkTransactionsReversal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBulkTransactionsReversal.vue?vue&type=style&index=0&id=52bd9a4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports